/*
 * Dropdowns
 */

import $ from "jquery";

export default function() {
    const el = document.querySelector(".nav-toggle");
    if(el){
        el.addEventListener("click", function(e) {
            e.preventDefault();
            document.querySelector(".nav-container .nav-menu").classList.toggle("show");
        });
    }

    // Handle dropdown toggle buttons (desktop)
    document.querySelectorAll(".dropdown-toggle").forEach(element => {
        element.addEventListener("click", function(e) {
            e.preventDefault();
            const dropdown = this.closest('li').querySelector('ul.dropdown-menu');
            if(dropdown){
                dropdown.classList.toggle("show");
            }
        });
    });

    // Handle mobile dropdown behavior
    function isMobile() {
        return window.innerWidth <= 768; // md breakpoint
    }

    // Handle window resize to update mobile behavior
    window.addEventListener("resize", function() {
        // Close all dropdowns when switching from mobile to desktop
        if (!isMobile()) {
            document.querySelectorAll(".dropdown-menu.show").forEach(dropdown => {
                dropdown.classList.remove("show");
            });
        }
    });

}


// WEBPACK FOOTER //
// ./src/js/partials/dropdowns.js